import React, { useState, useEffect } from 'react';
import { getWeather } from '../../../utils/WeatherApiService';
import './Weather.css';

const Weather = props => {

    const [weatherSymbol, setWeatherSymbol] = useState('');
    const [loading, setLoading] = useState(true);
    const [minTemperature, setMinTemperature] = useState('');
    const [maxTemperature, setMaxTemperature] = useState('');
    const [minWindSpeed, setMinWindSpeed] = useState('');
    const [maxWindSpeed, setMaxWindSpeed] = useState('');
    const [precipitation, setPrecipitation] = useState('');

    async function getWeatherLocal() {
        setLoading(true);

        try {
            var weather = await getWeather();
            setWeatherSymbol(weather.symbolCode);
            setMinTemperature(weather.minTemperature);
            setMaxTemperature(weather.maxTemperature);
            setMinWindSpeed(weather.minWindSpeed);
            setMaxWindSpeed(weather.maxWindSpeed);
            setPrecipitation(weather.precipitation);
        }
        catch (error) {
            setWeatherSymbol('error');
            console.error('Feil ved henting av værdata:', error);
        }

    setLoading(false);
}

useEffect(() => {

    getWeatherLocal();
}, []);

if (loading) {
    return (
        <div className="weather">
            <div className="weatherSpinner"></div>
        </div>
    );
}
else {
    return (
        <div onClick={() => getWeatherLocal()} className="weather">
            Været i dag:
            <img className="weatherImage" src={`/images/weather/${weatherSymbol}.png`}></img>
            <div className="weatherMeta">Nedbør: <span className="precipitation">{precipitation} mm</span></div>
            <div className="weatherMeta">Temp: <span className="weatherData"><span className={minTemperature < 0 ? "minusTemperature" : "plussTemperature"}>{minTemperature}&#730;</span> / <span className={maxTemperature < 0 ? "minusTemperature" : "plussTemperature"}>{maxTemperature}&#730;</span></span></div>
        </div>
    );
}
};

export default Weather;
